// A card row in Dropdown.Envs' Domains group. The whole card is the control:
// it hands off to the Infra canvas's connect-domain modal, pre-scoped to the
// project this canvas is editing (shared/functions/openProjectDomainFlow.js).
// Was a dead end — the arrow button had no handler and nothing else did.
// Rows override `onClick` to pick the modal step ('link' | 'new').
export const DomainItem = {
  extends: ['Flex'],
  gap: 'Z',
  padding: 'Z Z2 Y',
  round: 'radiusControl',
  cursor: 'pointer',
  ':hover': { background: 'hover' },
  onClick: (e, el) => {
    e.preventDefault()
    el.call('openProjectDomainFlow', { step: 'link' })
  },
  Icon: {
    margin: 'V2 - -',
    name: 'network',
    fontSize: 'A1'
  },
  Hgroup: {
    flow: 'y',
    margin: '- B - -',
    gap: 'X',
    H: {
      color: 'title',
      tag: 'span',
      text: '{{ publish.domains.custom | polyglot }}'
    },
    P: {
      margin: '0',
      fontSize: 'Y2',
      fontWeight: '400',
      color: 'paragraph',
      overflow: 'hidden',
      overflowWrap: 'anywhere',
      whiteSpace: 'wrap',
      textOverflow: 'anywhere',
      lineBreak: 'anywhere',
      text: '{{ publish.domains.customHint | polyglot }}'
    }
  },
  Buttons: {
    hide: (el) => el.getRootState('tier') === 'starter',
    margin: '-X -X - auto',
    childExtends: 'IconButton',
    childProps: {
      theme: 'transparent',
      padding: 'Y'
    },
    EnvOpen: {
      icon: 'arrow up right',
      color: 'title',
      // Accessible name for the icon-only button (IconButton mirrors `title`
      // onto aria-label); its click bubbles to the card's handler above.
      title: (el) => el.call('polyglot', 'publish.domains.custom')
    }
  },
  Upgrade: {
    extends: 'Link',
    color: 'blue',
    text: '{{ publish.action.upgrade | polyglot }}',
    margin: '- - - auto',
    alignSelf: 'start',
    whiteSpace: 'nowrap',
    fontSize: 'Z2',
    lineHeight: 1,
    ':hover': {
      textDecoration: 'underline'
    },
    onClick: (f, el, st) => {
      // Stop the bubble — the card's own handler would open pricing a
      // second time for the starter tier.
      f.stopPropagation()
      el.call('openRouterModal', '/settings', {
        key: '/pricing'
      })
    },
    hide: (el) => el.getRootState('tier') !== 'starter'
  }
}
